interface GetConditionsReturnType {
  isSomethingToShow: boolean;
}

interface GetConditionsProps {
  isSubCategory?: boolean;
  areTransactions: boolean;
  areSubcategories: boolean;
  value: number;
}

export const getConditions = ({
  isSubCategory,
  areTransactions,
  areSubcategories,
  value,
}: GetConditionsProps): GetConditionsReturnType => {
  const isMainCategory = !isSubCategory;
  const isValuePositive = value > 0;
  const isMainCategoryWithPositiveValue = isMainCategory && isValuePositive;
  const isMainCategoryWithPositiveValueAndNoSubcategories =
    isMainCategoryWithPositiveValue && !areSubcategories;
  const isSomethingToShow =
    areSubcategories ||
    areTransactions ||
    isMainCategoryWithPositiveValueAndNoSubcategories;
  return {
    isSomethingToShow,
  };
};

export default {
  getConditions,
};
